import Tag from '@/atoms/Tag/Tag'
import Filters from '@/services/Filters/Filters'
import FilterGroup, { FilterOption } from '@/ts/interfaces/global/FilterGroup'

function CategoryTags({ filters }: { filters: FilterGroup }) {
  const currentFilters = Filters.get() || {}

  const categoryTags = Object.entries(filters).reduce(
    (tags: [string, FilterOption[]][], [key, values]) => {
      const matchedFilters = values.filter(({ id }) =>
        currentFilters[key]?.includes(id)
      )
      tags.push([key, matchedFilters])
      return tags
    },
    []
  )
  return (
    <>
      {categoryTags?.map(([category, values]) =>
        values.map(({ id, name }) => {
          const key = category + name + id
          return (
            <Tag
              key={key}
              value={name}
              onRemove={() => Filters.remove(id, category)}
            />
          )
        })
      )}
    </>
  )
}

export default CategoryTags
